import {LegacyWBIcon} from '@wandb/common/components/elements/LegacyWBIcon';
import {NavLink} from '@wandb/common/util/links';
import React, {FC, Fragment, memo, MouseEvent, ReactNode} from 'react';
import {Breadcrumb} from 'semantic-ui-react';

import {useIsAdminModeActiveAndIsNotLocalEnv} from '../util/admin';
import * as S from './Breadcrumbs.styles';
export type BreadcrumbPart = {
  label: string;
  beforeLabel?: ReactNode;
  afterLabel?: ReactNode;

  to?: string; // Uses our `NavLink` component which avoids a full page reload
  href?: string; // Uses an `<a>` tag which causes a full page reload

  onClick?: (e: MouseEvent) => void;
};

type BreadcrumbsProps = {
  parts: BreadcrumbPart[];
};

const BreadcrumbsComp: FC<BreadcrumbsProps> = ({parts}) => {
  const showAdminBanner = useIsAdminModeActiveAndIsNotLocalEnv();
  return (
    <S.BreadcrumbsWrapper
      className="nav-breadcrumbs-wrapper"
      showAdminBanner={showAdminBanner}>
      <Breadcrumb className="nav-breadcrumbs" size="small">
        {parts.map((part, i) => (
          <Fragment key={i}>
            {i > 0 && (
              <Breadcrumb.Divider icon={<LegacyWBIcon name="next" />} />
            )}
            <Breadcrumb.Section>
              {part.beforeLabel}
              <BreadcrumbSegment part={part} />
              {part.afterLabel}
            </Breadcrumb.Section>
          </Fragment>
        ))}
      </Breadcrumb>
    </S.BreadcrumbsWrapper>
  );
};

const Breadcrumbs = memo(BreadcrumbsComp);

export default Breadcrumbs;

type BreadcrumbSegmentProps = {part: BreadcrumbPart};

const BreadcrumbSegmentComp: FC<BreadcrumbSegmentProps> = ({
  part: {label, to, href, onClick},
}) => {
  if (to) {
    return (
      <NavLink to={to} onClick={onClick}>
        {label}
      </NavLink>
    );
  }

  if (href) {
    return (
      // eslint-disable-next-line wandb/no-a-tags
      <a href={href} onClick={onClick}>
        {label}
      </a>
    );
  }

  return <span onClick={onClick}>{label}</span>;
};

const BreadcrumbSegment = memo(BreadcrumbSegmentComp);
